/**
 * Created by zqy on 2018/8/20 0020.
 */

const ecommerce = {
  state: {

  },
  mutations: {

  },
  actions: {

  }
}

export default ecommerce



// WEBPACK FOOTER //
// ./src/store/modules/ecommerce.js